function getEnabledStatus(enabledAttribute) {
    if (enabledAttribute) {
        switch (enabledAttribute.value) {
            case "true":
                return "Enabled";
            case "false":
                return "Disabled";
            default:
                return "";
        }
    }
}

function parseValues(section, callback) {
    const values = section.getElementsByTagName("Value");
    for (const value of values) {
        const name = value.attributes["Name"].value;
        const val = value.attributes["Value"].value;
        const unit = value.attributes["Unit"] ? value.attributes["Unit"].value : "";
        callback("", name, val, unit);
    }
}

export function parseReport(reportStr, callback) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(reportStr, "text/xml");

    const sections = xmlDoc.getElementsByTagName("Section");
    for (const section of sections) {
        const value = section.attributes["Name"].value;
        const enabled = getEnabledStatus(section.attributes["Enabled"]);
        callback(value, "", enabled, "");
        parseValues(section, callback);
    }
}
